<template>
  <ExecutionResultsDialog title="Report generation" ref="executionResultsDialog">
    <template #title="{ isError }">
      <span v-if="isError">
        <v-icon class="mr-1" large color="warning">warning</v-icon>
        Failed to generate report.
      </span>
      <span v-else>
        <v-icon class="mr-1" large color="success">check_circle</v-icon>
        Report generated successfully.
      </span>
    </template>
    <template #actions="{ }">
      <PrimaryBtn icon="refresh" color="primary" @click="generateAgain()">
        Generate again
      </PrimaryBtn>
    </template>
    <template #next="{ fileResults }">
      <PrimaryBtn icon="open_in_browser" color="primary" :to="{ name: 'rFrameworkViewer', params: { fileResults } }">
        View report
      </PrimaryBtn>
      <SecondaryBtn icon="file_download" color="primary" @click="downloadReport(fileResults)">
        Download offline
      </SecondaryBtn>
    </template>
  </ExecutionResultsDialog>
</template>

<script>
  import { downloadFileResults } from '@/helpers/download'
  import { createNamespacedHelpers } from 'vuex'
  const app = createNamespacedHelpers('app')

  export default {
    data: () => ({
      reportParams: null,
    }),
    methods: {
      ...app.mapActions(['setSnackbar']),
      show(reportData, reportParams) {
        this.reportParams = reportParams
        this.$refs.executionResultsDialog.show(reportData)
      },
      downloadReport(fileResults) {
        try {
          downloadFileResults(fileResults)

          this.setSnackbar({
            text: 'Report downloaded.',
            color: 'success',
            icon: 'done',
          })
        } catch (error) {
          this.setSnackbar({
            text: 'Failed to download report. ' + error,
            color: 'error',
            icon: 'error',
          })
        }
      },
      generateAgain() {
        this.$emit('retry', this.reportParams)
      },
    },
  }
</script>